import React, { useEffect } from 'react'
import './App.scss'
import GateKeeper from './gateKeeper'
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  useEffect(() => {
    const isSafari = /^((?!chrome|android|crios|fxios|edgios).)*safari/i.test(navigator.userAgent)
    if (!isSafari) return undefined

    const canScroll = (element, deltaX, deltaY) => {
      const style = window.getComputedStyle(element)
      const isDocument = element === document.scrollingElement
      const canScrollY = (isDocument || /(auto|scroll)/.test(style.overflowY)) && element.scrollHeight > element.clientHeight
      const canScrollX = (isDocument || /(auto|scroll)/.test(style.overflowX)) && element.scrollWidth > element.clientWidth
      const scrollsY = canScrollY && ((deltaY < 0 && element.scrollTop > 0) ||
        (deltaY > 0 && element.scrollTop + element.clientHeight < element.scrollHeight))
      const scrollsX = canScrollX && ((deltaX < 0 && element.scrollLeft > 0) ||
        (deltaX > 0 && element.scrollLeft + element.clientWidth < element.scrollWidth))
      return scrollsY || scrollsX
    }

    const handleWheel = (event) => {
      let scrollContainer = event.target instanceof Element ? event.target : null
      while (scrollContainer && scrollContainer !== document.body &&
        !canScroll(scrollContainer, event.deltaX, event.deltaY)) {
        scrollContainer = scrollContainer.parentElement
      }
      if (!scrollContainer || scrollContainer === document.body) {
        scrollContainer = document.scrollingElement
      }
      if (!scrollContainer || !canScroll(scrollContainer, event.deltaX, event.deltaY)) return

      const { scrollLeft, scrollTop } = scrollContainer
      const { deltaX, deltaY } = event
      requestAnimationFrame(() => {
        if (deltaY && scrollContainer.scrollTop === scrollTop) scrollContainer.scrollTop += deltaY
        if (deltaX && scrollContainer.scrollLeft === scrollLeft) scrollContainer.scrollLeft += deltaX
      })
    }

    document.addEventListener('wheel', handleWheel, { capture: true, passive: true })
    return () => document.removeEventListener('wheel', handleWheel, { capture: true })
  }, [])

  return (
    <div className='App'>
      <GateKeeper />
    </div>
  )
}

export default App
